// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Plus } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconPlus(props: any) {
    return <IconBase icon={Plus} {...props} />
  }

  export default IconPlus
  